// src/config/api.js
const BASE_CATEGORY_URL = `${process.env.REACT_APP_API_BASEURL}/api/categories`;
const BASE_ITEM_URL = `${process.env.REACT_APP_API_BASEURL}/api/items`;

/**
 * Fetch all categories from the backend.
 */
export const fetchCategories = async () => {
  try {
    const response = await fetch(BASE_CATEGORY_URL);
    if (!response.ok) throw new Error('Failed to fetch categories');
    return await response.json();
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};

/**
 * Add a new category to the backend.
 * @param {Object} category - The category to add (contains name and label).
 */
export const addCategory = async (category) => {
  try {
    const response = await fetch(BASE_CATEGORY_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(category),
    });

    if (!response.ok) throw new Error('Failed to add category');
    return await response.json();
  } catch (error) {
    console.error('Error adding category:', error);
    throw error;
  }
};

/**
 * Update an existing category by ID.
 * @param {string} id - The ID of the category to update.
 * @param {Object} updatedData - The updated data (name and label).
 */
export const updateCategory = async (id, updatedData) => {
  try {
    const response = await fetch(`${BASE_CATEGORY_URL}/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updatedData),
    });

    if (!response.ok) throw new Error('Failed to update category');
    return await response.json();
  } catch (error) {
    console.error('Error updating category:', error);
    throw error;
  }
};

/**
 * Delete a category by ID.
 * @param {string} id - The ID of the category to delete.
 */
export const deleteCategory = async (id) => {
  try {
    const response = await fetch(`${BASE_CATEGORY_URL}/${id}`, {
      method: 'DELETE',
    });

    if (!response.ok) throw new Error('Failed to delete category');
    return await response.json();
  } catch (error) {
    console.error('Error deleting category:', error);
    throw error;
  }
};

/**
 * Add a new item to the backend.
 * @param {FormData} itemData - The item data to add, including a file for the image.
 */
export const addItem = async (itemData) => {
  try {
    const response = await fetch(BASE_ITEM_URL, {
      method: 'POST',
      body: itemData, // FormData automatically sets the correct headers
    });

    if (!response.ok) throw new Error('Failed to add item');
    return await response.json();
  } catch (error) {
    console.error('Error adding item:', error);
    throw error;
  }
};

export const fetchItems = async () => {
    try {
      const response = await fetch(BASE_ITEM_URL);
      if (!response.ok) throw new Error('Failed to fetch items');
      return await response.json();
    } catch (error) {
      console.error('Error fetching items:', error);
      throw error;
    }
  };
  
  /**
   * Update an existing item by ID.
   * @param {string} id - The ID of the item to update.
   * @param {FormData} updatedData - The updated item data, including a file for the image if changed.
   */
  export const updateItem = async (id, updatedData) => {
    try {
      const response = await fetch(`${BASE_ITEM_URL}/${id}`, {
        method: 'PUT',
        body: updatedData, // FormData handles headers automatically
      });
  
      if (!response.ok) throw new Error('Failed to update item');
      return await response.json();
    } catch (error) {
      console.error('Error updating item:', error);
      throw error;
    }
  };
  
  /**
   * Delete an item by ID.
   * @param {string} id - The ID of the item to delete.
   */
  export const deleteItem = async (id) => {
    try {
      const response = await fetch(`${BASE_ITEM_URL}/${id}`, {
        method: 'DELETE',
      });
  
      if (!response.ok) throw new Error('Failed to delete item');
      return await response.json();
    } catch (error) {
      console.error('Error deleting item:', error);
      throw error;
    }
  };
